module.exports = __webpack_public_path__ + "img/lupa-img.94e91ce.png";